import { render } from "./RefundOrderList.vue?vue&type=template&id=60671f06&scoped=true"
import script from "./RefundOrderList.vue?vue&type=script&lang=js"
export * from "./RefundOrderList.vue?vue&type=script&lang=js"

import "./RefundOrderList.vue?vue&type=style&index=0&id=60671f06&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60671f06"]])

export default __exports__